import { ArrowIconLight } from '@/ui';
import { PaginationWrap } from '../../../../components/common/Pagination/Pagination.styles';
import LinkButton from '../../../../components/common/button/LinkButton';

interface IProps {
	currentPageIndex: number;
	totalPages: number;
	getHref: (page: number) => string;
}

export function JobsPagination({
	currentPageIndex,
	totalPages,
	getHref,
}: IProps) {
	const prevIndex = currentPageIndex - 1;
	const prevDisabled = currentPageIndex === 0;
	const prevHref = prevDisabled ? '' : getHref(prevIndex);

	const nextIndex = currentPageIndex + 1;
	const nextDisabled = currentPageIndex === totalPages - 1;
	const nextHref = nextDisabled ? '' : getHref(nextIndex);

	return (
		<PaginationWrap>
			<LinkButton
				as={prevDisabled ? 'span' : 'a'}
				href={prevHref}
				aria-disabled={prevDisabled}
				role="link"
				aria-label="Previous"
				buttonType="secondary"
				icon={<ArrowIconLight style={{ transform: 'rotate(180deg)' }} />}
				iconPosition="left"
				shallow
			>
				Previous
			</LinkButton>

			<LinkButton
				as={nextDisabled ? 'span' : 'a'}
				href={nextHref}
				aria-disabled={nextDisabled}
				role="link"
				buttonType="secondary"
				aria-label="Next"
				icon={<ArrowIconLight />}
				shallow
			>
				Next {currentPageIndex + 1}/{totalPages}
			</LinkButton>
		</PaginationWrap>
	);
}
